module.exports = __webpack_public_path__ + "static/media/telephone.81b45a01.svg";